import useEntities from 'hooks/useEntities';
import RelationsEditable from 'components/RelationsEditable';

const SponsorPhases = ({ sourceEntityId, data, onChange }) => {
    const entities = useEntities();
    const sourceEntity = entities.Sponsor;
    const targetEntity = entities.Phase;

    return (
        <RelationsEditable 
            data={data}
            sourceEntity={sourceEntity} 
            targetEntity={targetEntity}
            sourceEntityId={sourceEntityId}
            emptyMessage={`This ${sourceEntity.displayName} does not have any ${targetEntity.displayNamePlural}`}
            onChange={onChange}
        />
    )    
}

export default SponsorPhases
